import React, { Component } from "react";
import {
  Form,
  FormField,
  TextBox,
  LinkButton,
  Messager,
  DateBox,
  NumberBox,
  Panel,
  ComboBox,
  Tree,
  FileButton,
} from "rc-easyui";

import { BASE_URL, API_URL } from "../../../constants/index";
import setTitle from "../../../helpers/TitleComponent";
import { Button } from "reactstrap";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import {
  isEmpty,
  isEmptyString,
  getFormattedDate,
  generateErrorString,
} from "../../../helpers";
import { getData } from "./Common";

const axios = require("axios");

export default class UpdateClient extends Component {
  provinceList = [
    { value: "Province 1", text: "Province 1" },
    { value: "Province 2", text: "Province 2" },
    { value: "Province 3", text: "Province 3" },
    { value: "Province 4", text: "Province 4" },
    { value: "Province 5", text: "Province 5" },
    { value: "Province 6", text: "Province 6" },
    { value: "Province 7", text: "Province 7" },
  ];

  wardList = [
    { value: 1, text: 1 },
    { value: 2, text: 2 },
    { value: 3, text: 3 },
    { value: 4, text: 4 },
    { value: 5, text: 5 },
    { value: 6, text: 6 },
    { value: 7, text: 7 },
    { value: 8, text: 8 },
    { value: 9, text: 9 },
    { value: 10, text: 10 },
    { value: 11, text: 11 },
    { value: 12, text: 12 },
    { value: 13, text: 13 },
    { value: 14, text: 14 },
    { value: 15, text: 15 },
    { value: 16, text: 16 },
    { value: 17, text: 17 },
    { value: 18, text: 18 },
    { value: 19, text: 19 },
    { value: 20, text: 20 },
    { value: 21, text: 21 },
    { value: 22, text: 22 },
    { value: 23, text: 23 },
    { value: 24, text: 24 },
    { value: 25, text: 25 },
    { value: 26, text: 26 },
    { value: 27, text: 27 },
    { value: 28, text: 28 },
    { value: 29, text: 29 },
    { value: 30, text: 30 },
    { value: 31, text: 31 },
    { value: 32, text: 32 },
    { value: 33, text: 33 },
  ];

  constructor(props) {
    super(props);
    this.updateBasicInfo = this.updateBasicInfo.bind(this);
    this.basic_info = React.createRef();
    this.clientaccessinfo = React.createRef();
    this.getClientById = this.getClientById.bind(this);
    this.renderAccessModules = this.renderAccessModules.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);

    this.state = {
      isLoading: false,
      allMarketingAgentList: [],
      file: [],
      clientbasicinfo: {
        enabled: true,
        clientid: "",
        organizationname: "",
        provience: "",
        city: "",
        wardno: "",
        addressone: "",
        addresstwo: "",
        phoneno: "",
        altphone: "",
        altphonetwo: "",
        weburl: "",
        systemurl: "",
        contactpersonname: "",
        mobileno: "",
        altmobile: "",
        emailaddress: "",
        panvatnumber: "",
        mrid: "",
        createdby: getCookie("username"),
      },
      clientaccessinfo: {
        clientid: "",
        startdate: new Date(),
        expirydate: new Date(),
        allowedsystemusers: "",
        allowedmodules: [],
        systemuserpermissions: [],
        renewcharge: "",
        installationcharge: "",
      },
      moduleArray: [],
      allAccessModule: [],
      rules: {
        clientbasicinfo: {
          organizationname: ["required"],
          mrid: ["required"],
          provience: ["required"],
          city: ["required"],
          wardno: ["required"],
          addressone: ["required"],
          phoneno: {
            required: true,
          },
          emailaddress: ["email"],
          contactpersonname: ["required"],
          mobileno: ["required"],
          panvatnumber: {
            required: true,
            length: {
              validator(value) {
                return value.length === 9 || value.length === 11;
              },
              message: "Pan/VAT number should either 9 digit or 11 digit",
            },
          },

          // weburl: {
          //   validation: {
          //     validator(value) {
          //       return value.match(
          //         /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
          //       );
          //     },
          //     message: "Enter a valid link",
          //   },
          // },
          // systemurl: {
          //   validation: {
          //     validator(value) {
          //       return value.match(
          //         /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
          //       );
          //     },
          //     message: "Enter a valid link",
          //   },
          // },
        },

        clientaccessinfo: {
          startdate: ["required"],
          expirydate: ["required"],
          allowedsystemusers: ["required"],
          renewcharge: {
            required: true,
            positiveNumber: {
              validator(value) {
                return value >= 0;
              },
              message: "This field should be a postive number",
            },
          },
          installationcharge: {
            required: true,
            positiveNumber: {
              validator(value) {
                return value >= 0;
              },
              message: "This field should be a postive number",
            },
          },
        },
      },
    };
  }

  async componentDidMount() {
    setTitle("Client Registration");
    var pageURL = window.location.href;
    var lastURLSegment = pageURL.substr(pageURL.lastIndexOf("/") + 1);
    this.getPricePlanForComboBox();
    this.getMarketinRepresentativeForComboBox();
    this.getClientById(lastURLSegment);
    let resp = await this.getDisplayModules();
    if (resp) {
      let reslt = await this.getRoleData(lastURLSegment);
      if (reslt) {
        this.handleRowCheck();
      }
    }
  }

    //function to handle image select option
    handleSelect = (file) => {
      console.log('handleSelect')
      if (file.length === 1) {
        if (file[0].size > 250000) {
          console.log('250000')
          this.messager.alert({
            title: 'warning',
            icon: 'warning',
            msg: 'Maximum upload image size 250kb',
          })
          return
        }
        if (
          file[0].type !== 'image/png' &&
          file[0].type !== 'image/jpg' &&
          file[0].type !== 'image/jpeg'
        ) {
          console.log('type')
          return
        }
      }
      this.setState({ file: file }, () => {
        console.log(this.state.file)
      })
    }
  
    //function to cancle selected image
    onImageCancleHandle = () => {
      this.fileInput.fileRef.value = ''
      this.setState({ file: [] })
    }
  

  async getClientById(lastURLSegment) {
    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");
    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };
    var url = API_URL + "api/clientreginfo?clientid=" + lastURLSegment;

    this.setState({
      isLoading: true,
    });
    if (access_token != null) {
      axios
        .get(url, axiosConfig)
        .then((response) => {
          if (response.status === 200 && response.data.status) {
            var data = response.data.object;
            //console.log(response);
            let permissions = data["allowedmodules"].split(",");
            var clientbasicinfo = {
              enabled: data["enabled"],
              clientid: lastURLSegment,
              organizationname: data["organizationname"],
              provience: data["provience"],
              city: data["city"],
              wardno: data["wardno"],
              addressone: data["addressone"],
              addresstwo: data["addresstwo"],
              phoneno: data["phoneno"],
              altphone: data["altphone"],
              altphonetwo: data["altphonetwo"],
              weburl: data["weburl"],
              contactpersonname: data["contactpersonname"],
              mobileno: data["mobileno"],
              altmobile: data["altmobile"],
              emailaddress: data["emailaddress"],
              panvatnumber: data["panvatnumber"],
              mrid: data["mrId"],
              systemurl: data["systemUrl"] == null ? "" : data["systemUrl"],
              createdby: getCookie("username"),
            };

            var clientaccessinfo = {
              clientid: lastURLSegment,
              startdate: new Date(data["startdate"]),
              expirydate: new Date(data["expirydate"]),
              allowedsystemusers: data["allowedsystemuser"],
              priceplanid: data["priceplanid"],
              createdby: getCookie("username"),
              databasename: data["databsename"],
              renewcharge: data["renewcharge"],
              installationcharge: data["installationcharge"],
              allowedmodules: permissions,
              systemuserpermissions: [],
            };

            // for (let i = 0; i < permissions.length; i++) {
            //   document.getElementById(`${permissions[i]}`).checked = true;
            // }
            this.setState(
              {
                isLoading: false,
                clientbasicinfo: clientbasicinfo,
                clientaccessinfo: clientaccessinfo,
              },
              () => {
                this.basic_info.current.validate(
                  async (basic_info_errors) => {}
                );
                this.clientaccessinfo.current.validate(
                  async (basic_info_errors) => {}
                );
              }
            );
          } else {
            this.setState({
              isLoading: false,
            });
            alert("Error Loading Data");
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            isLoading: false,
          });
          alert("Error Loading Data");
        });
    } else {
      //Access Token Expired.
      //Generate new Access Token using Refresh Token.
      const resp = await getAccessToken();
      if (resp) {
        this.getClientById();
      }
    }
  }

  updateBasicInfo() {
    const { clientbasicinfo } = this.state;
    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");

    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };
    var pageURL = window.location.href;
    var lastURLSegment = pageURL.substr(pageURL.lastIndexOf("/") + 1);

    var data = {
      clientbasicinfo: clientbasicinfo,
    };
            
    let emptyfile = new File([''], '', {
      type: 'image/png',
    })

    let bodyFormData = new FormData()

    bodyFormData.append('file', this.state.file.length > 0 ? this.state.file[0] : emptyfile)
    bodyFormData.append('jsonData', JSON.stringify(data))

    this.basic_info.current.validate(async (basic_info_errors) => {
      if (isEmpty(basic_info_errors)) {
        if (access_token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          axios
            .post(
              API_URL + "api/updatebasicinfo?clientid=" + lastURLSegment,
              bodyFormData,
              axiosConfig
            )
            .then((response) => {
              if (response.status === 200) { 
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    reload: true,
                  }); // CLient  Updated Successfully ie. 200
                } else {
                  var message = "";
                  if (response.data.object) {
                    response.data.object.forEach((row, i) => {
                      message += "<p>" + row + "</p>";
                    });
                  } else {
                    message = response.data.message;
                  }
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  });
                }

                // this.props.formClear();
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              console.log(error);
              this.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.defaultMessage +
                      "</p>";
                  });
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.updateBasicInfo();
          }
        }
      } else {
        generateErrorString(basic_info_errors);
      }
    });
  }

  updateAccessInfo() {
    let clientaccessinfo = Object.assign({}, this.state.clientaccessinfo);
    let accessModule = this.getCheckedRows();
    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");

    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };

    //var allowedmodulesString = clientaccessinfo["allowedmodules"].join();
    var allowedmodulesString = this.state.moduleArray;
    let allowedmod = [];
    allowedmodulesString.map((ele, i) => {
      if (accessModule.indexOf(ele.toLowerCase()) >= 0) {
        allowedmod.push(ele);
      }
    });
    clientaccessinfo["allowedmodules"] = allowedmod.join();
    var pageURL = window.location.href;
    var lastURLSegment = pageURL.substr(pageURL.lastIndexOf("/") + 1);
    clientaccessinfo["startdate"] = getFormattedDate(
      clientaccessinfo["startdate"]
    );
    clientaccessinfo["expirydate"] = getFormattedDate(
      clientaccessinfo["expirydate"]
    );
    clientaccessinfo["systemuserpermissions"] = accessModule;
    var data = {
      clientaccessinfo: clientaccessinfo,
    };

    this.clientaccessinfo.current.validate(async (basic_info_errors) => {
      if (isEmpty(basic_info_errors)) {
        if (access_token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          // data.clientaccessinfo.expirydate = getFormattedDate(expirydate);
          // data.clientaccessinfo.startdate = getFormattedDate(startdate);
          axios
            .post(
              API_URL + "api/updateaccessinfo?clientid=" + lastURLSegment,
              data,
              axiosConfig
            )
            .then((response) => {
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                });
                clientaccessinfo["expirydate"] = new Date();
                clientaccessinfo["startdate"] = new Date();
                if (response.data.status) {
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    reload: true,
                  }); // CLient  Updated Successfully ie. 200
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message,
                  });
                }

                // this.props.formClear();
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              //console.log(error);
              // this.messager.alert({
              //   title: "Error",
              //   msg: "Internal Server Error",
              //   reload: false,
              // });
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.updateBasicInfo();
          }
        }
      } else {
        generateErrorString(basic_info_errors);
      }
    });
  }

  handleCheckAll() {
    let items = document.getElementsByName("modules[]");
    if (document.getElementById("all").checked) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].type === "checkbox") items[i].checked = true;
      }
    } else {
      for (let i = 0; i < items.length; i++) {
        if (items[i].type === "checkbox") items[i].checked = false;
      }
    }
  }
  handleChange(form_name, name, value) {
    let user = Object.assign({}, this.state[form_name]);
    if (name === "phoneno" || name === "altphone") {
      var a = value.replace(/[^\d.-]/g, "");

      user[name] = a;
    } else {
      user[name] = value;
    }

    this.setState({ [form_name]: user }, () => console.log(user));
  }

  handleCheckboxChange() {
    this.setState(
      {
        clientaccessinfo: {
          ...this.state.clientaccessinfo,
          allowedmodules: [...this.state.clientaccessinfo.allowedmodules],
        },
      },
      () => {
        //console.log(this.state.clientaccessinfo);
      }
    );
  }

  async getPricePlanForComboBox() {
    var token = getCookie("access_token");
    var tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/allpriceplan/`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          if (response.status === 200 && !isEmpty(response.data)) {
            this.setState({
              pricePlanList: response.data.object,
            });
          }
        })
        .catch(function (error) {});
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getClientsForComboBox();
      }
    }
  }

  handleRowCheck() {
    let tble = document.getElementsByClassName("tree-title");
    let allAccessModule = this.state.allAccessModule;
    for (let i = 0; i < tble.length; i++) {
      if (allAccessModule.indexOf(tble[i].textContent) >= 0) {
        tble[i].previousSibling.className = "tree-checkbox tree-checkbox1";
      }
    }
  }

  handleCheckChange(nodes) {
    var systemuserpermissions = this.state.allAccessModule;
    //var allowedmodules = this.state.clientaccessinfo.allowedmodules;
    /* console.log("systemuserpermissions",systemuserpermissions,nodes); */
    for (var key in nodes) {
      var current = nodes[key];
      if (systemuserpermissions.indexOf(current.id) < 0) {
        systemuserpermissions.push(current.id);
      }

      /*if (
        allowedmodules.indexOf(current.firstparent) < 0 &&
        current.firstparent !== undefined
      ) {
        allowedmodules.push(current.firstparent);
      }*/
    }
    this.setState({
      clientaccessinfo: {
        ...this.state.clientaccessinfo,
        systemuserpermissions,
      },
    });
  }

  getCheckedRows() {
    let tble = document.getElementsByClassName("tree-title");
    let selectedModule = [];
    for (let i = 0; i < tble.length; i++) {
      if (
        tble[i].previousSibling.className === "tree-checkbox tree-checkbox1" ||
        tble[i].previousSibling.className === "tree-checkbox tree-checkbox2"
      ) {
        selectedModule.push(tble[i].textContent.toLowerCase());
      }
    }
    return selectedModule;
  }

  async getDisplayModules() {
    return new Promise(async (resolve) => {
      let access_token = getCookie("access_token");
      let token_type = getCookie("token_type");
      let axiosConfig = {
        headers: {
          authorization: token_type + " " + access_token,
          "Content-Type": "application/json",
        },
      };
      if (access_token != null) {
        this.setState({
          isLoading: true,
        });
        axios
          .get(API_URL + "public/displaymodulesdetail", axiosConfig)
          .then((response) => {
            if (response.status === 200 && response.data.status) {
              let dataObject = response.data.object;

              let displayModules = dataObject;
              let moduleArray = Object.keys(displayModules);
              moduleArray.map((resData, key) => {
                let modulesTreeData = getData(displayModules[resData], resData);
                this.setState({
                  [`modulesTreeData${resData}`]: modulesTreeData,
                });
              });
              this.setState({ moduleArray: moduleArray });
              resolve(true);
            } else {
              alert("Internal Server Error");
              resolve(false);
            }
          })
          .catch((error) => {
            this.setState({
              isLoading: false,
            });
            alert("Internal server error");
            resolve(false);
          });
      } else {
        const resp = await getAccessToken();
        if (resp) {
          this.getDisplayModules();
        }
      }
    });
  }

  getMarketinRepresentativeForComboBox = async () => {
    var token = getCookie("access_token");
    var tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/getmarketingagentforcombo/`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          if (response.status === 200 && !isEmpty(response.data)) {
            this.setState({
              allMarketingAgentList: response.data.object,
            });
          }
        })
        .catch(function (error) {});
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getClientsForComboBox();
      }
    }
  };
  getRoleData(id) {
    return new Promise(async (resolve) => {
      let tokenType = getCookie("token_type");
      let token = getCookie("access_token");
      let apiUrl = `${API_URL}api/displaymodulesdetailforclientid/${id}`;

      let headersConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${tokenType} ${token}`,
        },
      };
      let self = this;
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          if (response.status === 200) {
            if (!isEmpty(response.data)) {
              if (response.data.status === true) {
                let accessData = [];
                let dataObject = response.data.object;
                let moduleArray = Object.keys(dataObject);
                moduleArray.map((resData, key) => {
                  Object.keys(dataObject[resData]).map((nestedData, key) => {
                    accessData.push(nestedData);
                    dataObject[resData][nestedData].map((element) => {
                      accessData.push(element);
                    });
                  });
                  accessData.push(resData);
                });
                //console.log("accessData",accessData)
                /* var user = response.data.object;
                user["modulesArray"] = modulesArray;
                self.setState(
                  {
                    user: user,
                    modulesArray,
                    isLoading: false,
                    id: id,
                  },
                  () => {
                    self.clientaccessinfo.current.validate((errors) => {});
                  }
                ); */
                this.setState({ allAccessModule: accessData });
                resolve(true);
              } else {
                self.setState({
                  isLoading: false,
                  user: null,
                });
                alert(`${response.data.message}`);
                resolve(true);
              }
            } else {
              self.setState({
                isLoading: false,
              });
              alert("Internal Server Error.1");
              resolve(false);
            }
          } else {
            self.setState({
              isLoading: false,
            });
            alert("Internal Server Error2.");
            resolve(false);
          }
        })
        .catch((error) => {
          console.log("error", error);
          let response = error["response"];
          if (response !== undefined) {
            if (response.status === 400) {
              var message = "";
              response.data.errors.forEach((row, i) => {
                message +=
                  "<p style='margin-bottom:3px;'>" +
                  row.defaultMessage +
                  "</p>";
              });
              alert(message);
            } else {
              alert("Uncaught Error");
            }
          } else {
            alert("Internal Server Error3");
          }
          self.setState({
            isLoading: false,
          });
        });
    });
  }

  renderAccessModules() {
    return this.state.moduleArray.map((resData) => {
      return (
        <div className="col-lg-3">
          <Tree
            idField="id"
            treeField="text"
            data={this.state[`modulesTreeData${resData}`]}
            checkbox
            onCheckChange={this.handleCheckChange.bind(this)}
          ></Tree>
        </div>
      );
    });
  }

  render() {
    const clientbasicinfo = this.state.clientbasicinfo;
    const basic_info_rules = this.state.rules.clientbasicinfo;
    const { clientaccessinfo, allMarketingAgentList } = this.state;
    const clientaccessinforules = this.state.rules.clientaccessinfo;

    var fileName = ''
    if (this.state.file.length === 1) {
      fileName = this.state.file[0].name
    }

    return (
      <div className="container-fluid">
        <div className={this.state.isLoading ? "loadingmodel" : ""}></div>
        <div className="row">
          <div className="col-lg-12">
            <Messager
              ref={(ref) => (this.messager = ref)}
              showHeader={false}
              borderType="none"
              content={({ title, msg, buttons, reload }) => (
                <div className="alert-content">
                  <h3>{title}</h3>
                  <div
                    style={{ marginBottom: 5 }}
                    dangerouslySetInnerHTML={{ __html: msg }}
                  ></div>
                  <div className="m-buttons">
                    {buttons.map((button, index) => (
                      <LinkButton
                        key={index}
                        text={button.text}
                        onClick={() => {
                          this.messager.close(button);
                          if (reload) {
                            window.location = BASE_URL + "client-list";
                          }
                        }}
                      />
                    ))}
                  </div>
                </div>
              )}
            />
            <Panel
              collapsible
              title="Client Basic Info"
              bodyStyle={{ padding: 15, height: 690 }}
            >
              <Form
                ref={this.basic_info}
                model={clientbasicinfo}
                labelWidth={155}
                labelAlign="left"
                rules={basic_info_rules}
                onChange={this.handleChange.bind(this, "clientbasicinfo")}
              >
                <div className="row">
                  <div className="col-6">
                    <FormField name="organizationname" label="Client Name:">
                      <TextBox
                        value={clientbasicinfo.organizationname}
                      ></TextBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="provience" label="Provience :">
                      {/* <ComboBox
                        value={clientbasicinfo.provience}
                        data={this.provinceList}
                      ></ComboBox> */}
                      <TextBox value={clientbasicinfo.provience}></TextBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="city" label="City:">
                      <TextBox value={clientbasicinfo.city}></TextBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="wardno" label="Ward No:">
                      <NumberBox value={clientbasicinfo.wardno}></NumberBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="addressone" label="Address 1:">
                      <TextBox value={clientbasicinfo.addressone}></TextBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="addresstwo" label="Address 2:">
                      <TextBox value={clientbasicinfo.addresstwo}></TextBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="phoneno" label="Phone Number:">
                      <TextBox
                        value={clientbasicinfo.phoneno}
                        min={0}
                      ></TextBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="altphone" label="Alt Phone :">
                      <TextBox value={clientbasicinfo.altphone}></TextBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="altphonetwo" label="Alt Phone 2 :">
                      <TextBox value={clientbasicinfo.altphonetwo}></TextBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="weburl" label="Software Link :">
                      <TextBox value={clientbasicinfo.weburl}></TextBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="systemurl" label="System URL :">
                      <TextBox value={clientbasicinfo.systemurl}></TextBox>
                    </FormField>
                  </div>

                  <div className="col-6">
                    <FormField
                      name="contactpersonname"
                      label="Contact Person Name:"
                    >
                      <TextBox
                        value={clientbasicinfo.contactpersonname}
                      ></TextBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="mobileno" label="Mobile No:">
                      <TextBox value={clientbasicinfo.mobileno}></TextBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="altmobile" label="Alt Mobile No:">
                      <TextBox value={clientbasicinfo.altmobile}></TextBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="emailaddress" label="Email Address:">
                      <TextBox value={clientbasicinfo.emailaddress}></TextBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="panvatnumber" label="PAN/VAT Number:">
                      <TextBox value={clientbasicinfo.panvatnumber}></TextBox>
                    </FormField>
                  </div>
                  <div className="col-6">
                    <FormField name="mrid" label="Marketing Agent:">
                      <ComboBox
                        data={allMarketingAgentList}
                        editable={true}
                        value={clientbasicinfo.mrid}
                        textField="name"
                        valueField="id"
                        style={{ width: "100%" }}
                      ></ComboBox>
                    </FormField>
                  </div>

                  <div className="col-6">
                    <FormField name="enabled" label="Status:">
                      <ComboBox
                        data={[
                          { value: true, text: "Active" },
                          { value: false, text: "Inactive" },
                        ]}
                        editable={false}
                        value={clientbasicinfo.enabled}
                        style={{ width: "100%" }}
                      ></ComboBox>
                    </FormField>
                  </div>
                </div>
              </Form>
              <div className="d-flex justify-content-between mb-5">
                <p>Logo:</p>
                <div style={{ marginRight: "59.5rem" }}>
                  <FileButton
                    ref={(ref) => (this.fileInput = ref)}
                    accept="image/*"
                    value={this.state.file}
                    id="ccimemberphotoselect"
                    onSelect={(e) => this.handleSelect(e)}
                  >
                    Choose Logo
                  </FileButton>
                  <p
                    id="ccimemberRegistartionImageValidMessage"
                    style={{
                      color: isEmptyString(fileName) ? 'green' : 'blue',
                      position: 'absolute',
                      marginTop: "0px",

                    }}
                    className="pt-1"
                  >
                    {isEmptyString(fileName) ? (
                      <>
                        {`Only png / jpg /jpeg allowed`}
                        <br></br>
                        {`Maximum size 250kb`}
                      </>
                    ) : (
                      <>
                        {fileName}
                        <span
                          onClick={this.onImageCancleHandle}
                          style={{ color: 'red', fontSize: "19px", fontWeight: "700", cursor: "pointer", paddingLeft: "5px" }}
                          color="red"
                        >
                          X
                        </span>
                      </>

                    )}
                  </p>
                </div>
              </div>
              <div className="text-center">
                <Button color="primary" onClick={this.updateBasicInfo}>
                  Update Basic Info
                </Button>
              </div>
            </Panel>
          </div>
        </div>
        <hr />
        <div className="row" style={{ marginTop: 15, marginBottom: 15 }}>
          <div className="col-lg-12">
            <Panel title="Client Access Info" bodyStyle={{ padding: 20 }}>
              <Form
                ref={this.clientaccessinfo}
                model={clientaccessinfo}
                labelWidth={150}
                labelAlign="left"
                rules={clientaccessinforules}
                // labelPosition='left'
                onChange={this.handleChange.bind(this, "clientaccessinfo")}
              >
                <FormField name="startdate" label="Start Date:">
                  <DateBox
                    inputId="d2"
                    format="yyyy-MM-dd"
                    value={clientaccessinfo.startdate}
                    calendarOptions={{
                      validator: (date) => {
                        var now = new Date();
                        var d1 = new Date(
                          now.getFullYear(),
                          now.getMonth(),
                          now.getDate()
                        );

                        return d1 <= date;
                      },
                    }}
                    panelStyle={{ width: 250, height: 300, margin: "auto" }}
                  ></DateBox>
                  {/* <NumberBox value={license.startDate}></NumberBox> */}
                </FormField>
                <FormField name="expirydate" label="Expiry Date:">
                  <DateBox
                    inputId="d2"
                    format="yyyy-MM-dd"
                    value={clientaccessinfo.expirydate}
                    calendarOptions={{
                      validator: (date) => {
                        var now = new Date();
                        var d1 = new Date(
                          now.getFullYear(),
                          now.getMonth(),
                          now.getDate()
                        );

                        return d1 <= date;
                      },
                    }}
                    panelStyle={{ width: 250, height: 300, margin: "auto" }}
                  ></DateBox>
                </FormField>

                <FormField
                  name="allowedsystemusers"
                  label="No. of user Allowed:"
                >
                  <NumberBox
                    value={clientaccessinfo.allowedsystemusers}
                  ></NumberBox>
                </FormField>

                <FormField name="priceplanid" label="Price Plan:">
                  <ComboBox
                    textField="planName"
                    valueField="id"
                    data={this.state.pricePlanList}
                    value={clientaccessinfo.priceplanid}
                    style={{ width: "100%" }}
                  ></ComboBox>
                </FormField>
                <FormField name="renewcharge" label="Renew Charge:">
                  <NumberBox
                    value={clientaccessinfo.renewcharge}
                    prefix="Rs."
                    precision={2}
                    spinners={true}
                  ></NumberBox>
                </FormField>

                <FormField
                  name="installationcharge"
                  label="Installation Charge:"
                >
                  <NumberBox
                    prefix="Rs."
                    precision={2}
                    spinners={true}
                    value={clientaccessinfo.installationcharge}
                  ></NumberBox>
                </FormField>
              </Form>
              <h6>Allowed Modules</h6>
              <div className="row">{this.renderAccessModules()}</div>
              <div style={{ marginTop: 15, marginBottom: 5 }}>
                <center>
                  <Button
                    disabled={this.state.isLoading}
                    color="primary"
                    onClick={this.updateAccessInfo.bind(this)}
                  >
                    Update Access Info
                  </Button>
                </center>
              </div>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}
